<div class="flex flex-col w-full h-full" [style.max-height]="effectiveMaxHeight" [style.min-width]="effectiveMinWidth" *transloco="let t">
	<ara-dialog-header [title]="title() ?? t(effectiveTitleKey)" [subtitle]="subtitle()" (closed)="close()">
		<!-- Projection-Mode: der Aufrufer kann Steuerelemente in den Kopf projizieren ([araDialogHeaderActions]). -->
		<ng-content select="[araDialogHeaderActions]" ngProjectAs="[dialogHeaderActions]" />
	</ara-dialog-header>

	<mat-dialog-content class="flex-1 min-h-[120px] overflow-auto pb-2">
		@if (contentTemplate) {
			<ng-container *ngTemplateOutlet="contentTemplate; context: contentContext" />
		} @else {
			<ng-content />
		}
	</mat-dialog-content>

	@if (effectiveActions.length) {
		<mat-dialog-actions class="flex flex-row items-center justify-end border-t border-black/[0.08] px-6 py-4 gap-2">
			<ng-content select="[dialogFooterStart]" />
			@for (action of effectiveActions; track action.labelKey) {
				<span [matTooltip]="action.tooltipKey ? t(action.tooltipKey) : ''" [matTooltipDisabled]="!action.tooltipKey">
					<button
						araButton="flat"
						type="button"
						[color]="action.color ?? 'secondary'"
						[disabled]="isDisabled(action)"
						[loading]="isLoading(action)"
						(click)="invoke(action)">
						@if (action.icon) {
							<mat-icon>{{ action.icon }}</mat-icon>
						}
						{{ t(action.labelKey) }}
					</button>
				</span>
			}
		</mat-dialog-actions>
	}
</div>
